import { Navigate } from "react-router-dom";

const PublicRoute = ({ children }) => {
  const token = localStorage.getItem("token"); // vérifie si l'utilisateur est connecté

  if (token) {
    // si l'utilisateur est connecté, redirige vers home
    return <Navigate to="/" replace />;
  }

  return children;
};

export default PublicRoute;
